import { defineMessages } from 'react-intl';

export default defineMessages({
  userType: {
    id: 'adminConsole.userType',
    defaultMessage: 'Utente Azimut',
    description: 'User type',
  },
  menuItemDashboard: {
    id: 'adminConsole.menuItemDashboard',
    defaultMessage: 'Dashboard',
    description: 'Menu item dashboard label',
  },
  menuItemCustomerService: {
    id: 'adminConsole.menuItemCustomerService',
    defaultMessage: 'Supporto clienti',
    description: 'Menu item customer service label',
  },
  menuItemFiduciarie: {
    id: 'adminConsole.menuItemFiduciarie',
    defaultMessage: 'Gestione fiduciarie',
    description: 'Menu item fiduciarie label',
  },
  dashboardTitle: {
    id: 'adminConsole.dashboardTitle',
    defaultMessage: 'Admin Dashboard',
    description: 'Admin dashboard page title',
  },
  customerServiceCardTitle: {
    id: 'adminConsole.customerServiceCardTitle',
    defaultMessage: 'Supporto clienti',
    description: 'Title for customer service card in admin dashboard',
  },
  customerServiceCardDescription: {
    id: 'adminConsole.customerServiceCardDescription',
    defaultMessage:
      'Funzionalità per sblocco utenze,\nrecupero credenziali\ned impersonificazione',
    description: 'Description for customer service card in admin dashboard',
  },
  fiduciarieCardTitle: {
    id: 'adminConsole.fiduciarieCardTitle',
    defaultMessage: 'Gestione fiduciarie',
    description: 'Title for fiduciarie card in admin dashboard',
  },
  fiduciarieCardDescription: {
    id: 'adminConsole.fiduciarieCardDescription',
    defaultMessage: 'Censimento e modifica\nutenze fiduciarie',
    description: 'Description for fiduciarie card in admin dashboard',
  },
  goToFunctionality: {
    id: 'adminConsole.goToFunctionality',
    defaultMessage: 'vai alla funzionalità',
    description: 'Link label to navigate to functionality',
  },
  defaultAdminUser: {
    id: 'adminConsole.defaultAdminUser',
    defaultMessage: 'ADMIN USER',
    description: 'Default admin user name',
  },
  loginNotAuthorized: {
    id: 'adminConsole.login.notAuthorized',
    defaultMessage:
      "Il tuo utente non è abilitato all'accesso alla console di amministrazione.",
    description: 'Admin console login: user not in the allowed group',
  },
  loginFailed: {
    id: 'adminConsole.login.failed',
    defaultMessage:
      "Non è stato possibile completare l'accesso alla console di amministrazione.",
    description: 'Admin console login: popup closed or login error',
  },
  loginRetry: {
    id: 'adminConsole.login.retry',
    defaultMessage: 'Riprova',
    description: 'Admin console login: retry button',
  },
});
